import Vue from 'vue'
import Answer from '../views/Answer.vue'

Vue.config.productionTip = false

import VueResource from 'vue-resource'
Vue.use(VueResource)

new Vue({
  render: h => h(Answer)
}).$mount('#app')
